
    
    function modals() {
        const body = document.getElementsByTagName('body')[0];

        //common for all modals (required)
        let commonModal=document.querySelectorAll('.modal');
        let closeBtn = document.querySelectorAll(".modal-content__close");

        //common btn from header for all pages (required)
        if (document.querySelectorAll(".header__btn"))  {
            document.querySelectorAll(".header__btn").forEach((elem) => {

                elem.addEventListener('click', () => {

                    document.querySelectorAll("#modal__consultation").forEach(item=>{
                        item.style.display = "block";
                    });

                    body.classList.add('no-scroll');
                });
            });
        }

        //btn in tabs for main page
        if (document.querySelectorAll(".tabs__btn-inner")) { 

            document.querySelectorAll(".tabs__btn-inner").forEach((elem) => {

                elem.addEventListener('click', () => {
                    document.getElementById('modal__order').style.display = "block";
                    body.classList.add('no-scroll');
                });
            });
        }

        //btn-callback for page product-details
        if (document.querySelector("#product-details__callback")) {

            document.querySelector('#product-details__callback').onclick = function() {
                document.querySelector('#modal__callback').style.display = "block";
                body.classList.add('no-scroll');
            }
        }


        //btn-order for page product-details
        if (document.querySelector("#product-details__order")) {

            document.querySelector('#product-details__order').onclick = function() {
                document.querySelector('#modal__product-buy').style.display = "flex";
                body.classList.add('no-scroll');
            }
        }


        //common close for all pages (required)
        closeBtn.forEach((elem) => {

            elem.addEventListener('click', () => {
                body.classList.remove('no-scroll');
                
                commonModal.forEach(item=>{
                    item.style.display="none";;
                });
            });
        });

        //close by clicking on window (required)
        window.addEventListener('click', function (modal) {
            
            if (modal.target == document.querySelector("#modal__consultation")) {
                document.querySelector("#modal__consultation").style.display = "none";
                body.classList.remove('no-scroll');
            } 

            if (modal.target == document.getElementById('modal__order')) {
                document.getElementById('modal__order').style.display = "none";
                body.classList.remove('no-scroll');
            }

            if (modal.target == document.querySelector('#modal__callback')) {
                document.querySelector('#modal__callback').style.display = "none";
                body.classList.remove('no-scroll');
            }

            if (modal.target == document.querySelector('#modal__product-buy')) {
                document.querySelector('#modal__product-buy').style.display = "none";
                body.classList.remove('no-scroll');
            }

        });
    }

modals();